module.exports = __webpack_public_path__ + "media/images/lb/890-cc690ee40a4d5941ab7796bc69a6624e.svg";